import { RuleDecl } from "vue/types/options";
import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
import Users from "./Users";

export const validations: RuleDecl = {
    userAdminName: {
        emailRequired: required,
        minEmailLength: minLength(4),
        maxEmailLength: maxLength(300),
        email,
        unique: (value: string, component: Users) => {
            if (!!component) {
                return (component.adminUsers?.findIndex(u => u.email.localeCompare(value) === 0) < 0 ?? true) &&
                    (component.vipUsers?.findIndex(u => u.email.localeCompare(value) === 0) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
    userVIPName: {
        emailRequired: required,
        minEmailLength: minLength(4),
        maxEmailLength: maxLength(300),
        email,
        unique: (value: string, component: Users) => {
            if (!!component) {
                return (component.adminUsers?.findIndex(u => u.email.localeCompare(value) === 0) < 0 ?? false) &&
                    (component.vipUsers?.findIndex(u => u.email.localeCompare(value) === 0) < 0 ?? false);
            } else {
                return true;
            }
        },
    },
};

export const validationMessages = {
    emailRequired: "Email is required",
    minEmailLength: "Email must have at least {min} letters",
    maxEmailLength: "Email must have less than {max} letters",
    unique: "Email must be unique",
};
